module.exports = __webpack_public_path__ + "img/10551393_L.9f706fa0.png";